var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_2649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_2649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5502 11.9996L10.9002 19.3496C11.1502 19.5996 11.271 19.8913 11.2627 20.2246C11.2544 20.558 11.1252 20.8496 10.8752 21.0996C10.6252 21.3496 10.3335 21.4746 10.0002 21.4746C9.66686 21.4746 9.3752 21.3496 9.1252 21.0996L1.4252 13.4246C1.2252 13.2246 1.0752 12.9996 0.975195 12.7496C0.875195 12.4996 0.825195 12.2496 0.825195 11.9996C0.825195 11.7496 0.875195 11.4996 0.975195 11.2496C1.0752 10.9996 1.2252 10.7746 1.4252 10.5746L9.1252 2.87462C9.3752 2.62462 9.67103 2.50379 10.0127 2.51212C10.3544 2.52046 10.6502 2.64962 10.9002 2.89962C11.1502 3.14962 11.2752 3.44129 11.2752 3.77462C11.2752 4.10796 11.1502 4.39962 10.9002 4.64962L3.5502 11.9996Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.ef3df8b29d5db27dd271b4631077d5c3.svg";
export { ForwardRef as ReactComponent };